<script setup lang="ts">
import { computed, useAttrs } from 'vue'

import { iconMap } from './icons'

interface Props {
  name: string // 圖標名稱
  width?: string | number
  height?: string | number
  preserveColors?: boolean // 保留 SVG 原始顏色（多色圖標用）
}

const props = defineProps<Props>()

defineOptions({
  inheritAttrs: false
})

const attrs = useAttrs()

// 從映射表獲取圖標元件
const iconComponent = computed(() => {
  const icon = iconMap[props.name as keyof typeof iconMap]
  if (!icon) {
    console.warn(`Icon "${props.name}" not found in iconMap`)
  }
  return icon
})

const sizeStyle = computed(() => {
  const w = props.width ?? '24px'
  const h = props.height ?? '24px'
  return {
    width: typeof w === 'number' ? `${w}px` : w,
    height: typeof h === 'number' ? `${h}px` : h
  }
})
</script>

<template>
  <span v-bind="attrs" class="svg-icon-wrapper" :style="sizeStyle">
    <component :is="iconComponent" v-if="iconComponent" :class="props.preserveColors ? 'svg-icon-raw' : 'svg-icon'" />
  </span>
</template>

<style scoped>
.svg-icon-wrapper {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 0;
}

.svg-icon,
.svg-icon-raw {
  width: 100%;
  height: 100%;
  display: block;
}

/* 讓 SVG 繼承父元素的顏色（支援 Tailwind class） */
.svg-icon :deep(svg),
.svg-icon-raw :deep(svg) {
  width: 100%;
  height: 100%;
  display: block;
}

.svg-icon :deep(svg path) {
  fill: currentColor !important;
}

.svg-icon :deep(svg [stroke]) {
  stroke: currentColor !important;
}

.svg-icon :deep(svg circle) {
  fill: currentColor !important;
}

.svg-icon :deep(svg rect) {
  fill: currentColor !important;
}

.svg-icon :deep(svg polygon) {
  fill: currentColor !important;
}
</style>
